/** EU member states, excluding France which is stored as FRA. */
const EU_MEMBER_COUNTRY_CODES = new Set([
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
]);

export function resolveNationalityFlag(countryCode?: string | null): string {
  const code = String(countryCode ?? "").trim().toUpperCase();
  if (!code) {
    return "";
  }
  if (code === "FR" || code === "FRA") {
    return "FRA";
  }
  if (EU_MEMBER_COUNTRY_CODES.has(code)) {
    return "UE";
  }
  return "AUTRE";
}

export function getPersonNationalityCode(person: any): string {
  return String(
    person?.nationality?.type?.value
      || person?.nationality?.resourceUid
      || person?.citizenships?.[0]?.country?.resourceUid
      || ""
  ).trim();
}

export function applyPersonNationalityFlag(person: any, countryCode?: string | null) {
  if (!person) {
    return;
  }
  const code = countryCode !== undefined ? countryCode : getPersonNationalityCode(person);
  const flag = resolveNationalityFlag(code);
  if (!flag) {
    if (person.businessData && typeof person.businessData === "object") {
      delete person.businessData.nationalityFlag;
    }
    return;
  }
  if (!person.businessData || typeof person.businessData !== "object") {
    person.businessData = {};
  }
  person.businessData.nationalityFlag = flag;
}
